var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#546EDB",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M0 10.5C0 4.7 4.7 0 10.5 0S21 4.7 21 10.5 16.3 21 10.5 21 0 16.3 0 10.5Zm11.55-5.25a1.05 1.05 0 0 0-2.1 0v3.952a3.15 3.15 0 0 0 1.74 2.817l3.04 1.52a1.049 1.049 0 1 0 .94-1.878l-3.04-1.52a1.049 1.049 0 0 1-.58-.939V5.25Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a1a75b605ad0ba80fa3d6d40f33dd7e8.svg";
export { ForwardRef as ReactComponent };